import type { SxStyle } from '@aibees/shared/theme';

export const cardBase: SxStyle = {
  display: 'block',
  position: 'relative',
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'grey.300',
  borderRadius: 1,
  textDecoration: 'none',
  cursor: 'pointer',
  color: 'grey.800',
  transition:
    'transform .35s cubic-bezier(.2,.7,.2,1), box-shadow .35s cubic-bezier(.2,.7,.2,1), border-color .25s ease',
  boxShadow: '0 1px 0 rgba(15,23,42,.02)',
  '&:hover': {
    transform: 'translate3d(0, -3px, 0)',
    borderColor: 'primary.main',
    boxShadow:
      '0 -10px 24px -16px rgba(24,81,239,.35), 0 18px 36px -18px rgba(24,81,239,.45), 0 0 0 4px rgba(24,81,239,.08)',
  },
};

export const innerDivider: SxStyle = {
  borderColor: 'grey.300',
  backgroundColor: 'grey.300',
};
